import { FormSection, TableBody, TableHead, TableRow } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import type { IMedication } from '@frontend/components/interfaces/medication';
import { FormParagraphFormGroup } from '@frontend/components/fields/FormParagraphField';
import { MedicationsTableHeader } from '@frontend/components/pages/customControls/utils/v1/medications/MedicationsTableHeader';
import { MedicationsTableRow } from '@frontend/components/pages/customControls/utils/v1/medications/MedicationsTableRow';
import { ProfessionalSummaryDataTable } from '@frontend/components/pages/professionalSummaryData/ProfessionalSummaryDataTable';
import { fetchJson } from '@frontend/store/fetch';
import { getSelectedLanguage } from '@frontend/translate';

interface ProcessActivityMedicationsReadProps {
    patientUsesMedication: boolean | null;
    processActivityId: string;
    shouldRemoveSectionTitle?: boolean;
}

export function ProcessActivityMedicationsRead(props: ProcessActivityMedicationsReadProps) {
    const { shouldRemoveSectionTitle, patientUsesMedication, processActivityId } = props;
    const [medications, setMedications] = useState<IMedication[]>([]);
    const itemsPerPage = 50;
    const translate = getSelectedLanguage();

    useEffect(() => {
        if (patientUsesMedication) {
            loadMedications();
        }
    }, [patientUsesMedication]);

    if (patientUsesMedication === null) {
        return null;
    }

    return (
        <FormSection title={shouldRemoveSectionTitle ? '' : translate.medications.medication}>
            <FormParagraphFormGroup label={translate.medications.patientUsesMedication}>
                {patientUsesMedication ? translate.common.yes : translate.common.no}
            </FormParagraphFormGroup>

            {medications.length > 0 && (
                <ProfessionalSummaryDataTable isRead={true}>
                    <TableHead>
                        <TableRow>
                            <MedicationsTableHeader />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {medications.map((item: IMedication) => (
                            <TableRow key={item.id}>
                                <MedicationsTableRow medication={item} />
                            </TableRow>
                        ))}
                    </TableBody>
                </ProfessionalSummaryDataTable>
            )}
        </FormSection>
    );

    async function loadMedications() {
        const url = `/api/processActivities/${processActivityId}/medications?limit=${itemsPerPage}`;

        const results = await fetchJson(url, 'GET');
        setMedications(results.json.items);
    }
}
